import React from 'react';
import { motion } from 'framer-motion';
import { PlayCircle } from 'lucide-react';
export function CampaignVideo() {
  // To embed a YouTube video, replace the VIDEO_ID below with your YouTube video ID.
  // For example, if your YouTube URL is https://www.youtube.com/watch?v=abc123
  // then set videoId to 'abc123'
  const videoId = 'dt11HDMEUxY';
  const videoUrl = videoId ? `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1` : '';
  return <section className="py-24 md:py-32 bg-navy relative overflow-hidden" data-id="element-40">
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-41">
        <div className="absolute top-[-10%] right-[-5%] w-96 h-96 bg-sky rounded-full blur-[100px]" data-id="element-42"></div>
        <div className="absolute bottom-[-10%] left-[-5%] w-96 h-96 bg-red rounded-full blur-[100px]" data-id="element-43"></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10" data-id="element-44">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-45">
          <span className="text-red font-bold tracking-widest uppercase text-sm block mb-4" data-id="element-46">
            Campaign Launch
          </span>
          <h2 className="text-4xl md:text-5xl font-serif text-white mb-6" data-id="element-47">
            Watch the <span className="italic text-sky" data-id="element-48">Announcement</span>
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="aspect-video w-full rounded-sm overflow-hidden shadow-2xl bg-navy-light border border-white/10" data-id="element-49">
          {videoUrl ? <iframe src={videoUrl} title="Campaign Launch Video" className="w-full h-full" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-50" /> : <div className="w-full h-full flex flex-col items-center justify-center gap-6" data-id="element-51">
              <PlayCircle className="text-white/20" size={80} strokeWidth={1} data-id="element-52" />
              <span className="text-white/30 font-medium tracking-widest text-sm uppercase" data-id="element-53">
                Campaign Video Coming Soon
              </span>
            </div>}
        </motion.div>
      </div>
    </section>;
}